import * as bus from "@sinch/bus";
import { useAtomValue } from "jotai";
import { useState, useEffect } from "react";
import { DataCollectors } from "../../../analytics/eventTypes";
import { handleTrackEventPayload } from "../../../analytics/handleTrackEventPayload";
import { formatEasyClickEvent } from "../../../analytics/shellEventHandler";
import { shellListener } from "../../../analytics/shellEventListener";
import type { ShellUser } from "../../../api/types";
import { shouldHandleConsent } from "../../../components/CookieBanner/consent";
import { onesaasConsentAtom } from "../onesaas-consent-cookie";
import { useVendorConfigPlugin } from "../vendorConfig";

export const useSetBusListener = (user?: ShellUser | null) => {
  const [isListenerSet, setIsListenerSet] = useState(false);

  const onesaasConsent = useAtomValue(onesaasConsentAtom);
  const vendorPlugin = useVendorConfigPlugin();

  useEffect(() => {
    if (user) {
      const busTrackEventstHandler = handleTrackEventPayload(
        [DataCollectors.RudderStack, DataCollectors.Datadog],
        user,
        {},
        shouldHandleConsent(vendorPlugin),
        onesaasConsent
      );

      const terminateBusListener = bus.listen(async (message) => {
        // TODO: Fix typing in package, message type should be a string not unknown
        const trackEventMessage = message as bus.Message<string, unknown>;
        if (bus.isTrackEvent(trackEventMessage)) {
          busTrackEventstHandler(trackEventMessage.payload);
        }
      });
      const terminateShellListener = shellListener((event) => {
        const trackEventPayload = formatEasyClickEvent(event);
        if (trackEventPayload) {
          busTrackEventstHandler(trackEventPayload);
        }
      });
      setIsListenerSet(true);
      return () => {
        terminateBusListener();
        terminateShellListener();
      };
    }
    return;
  }, [user, onesaasConsent, vendorPlugin]);

  return isListenerSet;
};
